import { GROOMING_SEARCH_URL } from '@rover/react-lib/src/pages/grooming/constants';
import { ApiGroomingSearchRetrieveGroomingType } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveGroomingType';
import type { ApiGroomingSearchRetrieveParams } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveParams';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

const DEFAULT_GROOMING_TYPE = ApiGroomingSearchRetrieveGroomingType.full_groom;

export const getGroomingSearchParams = (
  seoLocation: SeoLocation
): ApiGroomingSearchRetrieveParams => {
  const { locality } = seoLocation.details;
  const centerlat = parseFloat(locality.latitude);
  const centerlng = parseFloat(locality.longitude);

  return {
    groomingType: DEFAULT_GROOMING_TYPE,
    location: locality.seoDisplayName,
    locationType: seoLocation.localityType,
    ...(Number.isFinite(centerlat) && { centerlat }),
    ...(Number.isFinite(centerlng) && { centerlng }),
  };
};

export const getGroomingSearchPageUrl = (params: ApiGroomingSearchRetrieveParams): string => {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  }

  return `${GROOMING_SEARCH_URL}?${query.toString()}`;
};
